import StaffPortal from './pages/StaffPortal.vue';

export default {'staff-portal': StaffPortal};
